module.exports = __webpack_public_path__ + "media/images/icons/icon_search_closed-17a839db56eb69649ab0e22437f6392a.svg";